import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardBlockedDomainsOption')(function discardBlockedDomainsOption(state) {
    var optionState = state.optionState;
    optionState.blockedDomains = null;
}));
//# sourceMappingURL=discardBlockedDomainsOption.js.map